export class History {
  constructor() {
    this.selector = {
      root: 'data-history',
      changeElement: 'data-history-change',
      timeline: 'data-history-timeline',
      recordEpoch: 'data-history-epoch',
      recordEpochJson: 'data-history-epoch-json',
      recordEvent: 'data-history-event',
      recordEventJson: 'data-history-event-json',
      buttonPrev: 'data-history-event-previous',
      buttonNext: 'data-history-event-next',
      wrapper: 'data-history-wrapper',
      intro: 'data-history-intro',
      start: 'data-history-start',
      link: 'data-history-link',
    };

    this.class = {
      animating: 'is-animating',
      fadeIn: 'is-fadein',
      fadeOut: 'is-fadeout',
      invisible: 'is-invisible',
      selected: 'is-selected',
      hidden: 'is-hidden',
    }

    if (this.getQuerySelector('root') !== null) {
      this.options = {
        animationDuration: 300,
        animationInProgress: false,
        changeBackground: true,
        defaultBackground: '',
        currentEvent: null,
      };

      this.object = {
        root: this.getQuerySelector('root'),
        intro: this.getQuerySelector('intro'),
        wrapper: this.getQuerySelector('wrapper'),
        image: this.getQuerySelector('changeElement', 'image'),
        year: this.getQuerySelector('changeElement', 'year'),
        text: this.getQuerySelector('changeElement', 'text'),
        link: this.getQuerySelector('changeElement', 'link'),
        background: this.getQuerySelector('changeElement', 'background'),
        timeline: this.getQuerySelector('timeline'),
      }

      this.initialize();
      this.clickEvents();
    }
  }

  initialize() {
    this.options.defaultBackground = this.object.background.getAttribute('src');

    this.displayEvent(this.getQuerySelector('recordEvent'));
  }

  handleSelectedState(eventObject, eventData) {
    let timeline = this.getQuerySelector('timeline');

    // Unset all selected classes
    for(let element of this.object.timeline.children) {
      element.classList.remove(this.class.selected);
    }

    // Set class on current event
    eventObject.classList.add(this.class.selected);

    // Set class on current epoch
    this.getQuerySelector('recordEpoch', eventData.epoch).classList.add(this.class.selected);

    // Scroll to position
    timeline.scrollTop = Math.max(eventObject.offsetTop - (timeline.clientHeight / 2 + eventObject.clientHeight / 2), 0);
  }

  async displayEvent(eventObject) {
    let self = this,
        data = JSON.parse(eventObject.getAttribute(self.selector.recordEventJson)),
        changeData = function(data) {
          let yearSplit = data.year.substr(0, 4).split('').reverse(),
              yearIterator = 0,
              yearSpanPosition = self.object.year.children.length;

          // Change year
          for (let char of yearSplit) {
            // Count up iterator for getting access on the correct span
            yearIterator++;

            // Set year character to correct span
            self.object.year.children[yearSpanPosition - yearIterator].children[0].textContent = char;
          }

          // Change background
          if (self.options.changeBackground) {
            if (data.background.length > 0) {
              self.object.background.setAttribute('src', data.background);
            } else {
              self.object.background.setAttribute('src', self.options.defaultBackground);
            }
          }

          // Change image
          if (data.image.length > 0) {
            self.object.image.setAttribute('src', data.image);
            self.object.image.classList.remove(self.class.hidden);
          } else {
            self.object.image.classList.add(self.class.hidden);
          }

          // Change text
          if (data.text.length > 0) {
            self.object.text.innerHTML = data.text;
            self.object.text.classList.remove(self.class.hidden);
          } else {
            self.object.text.classList.add(self.class.hidden);
          }

          // Change link
          if (data.link.length > 0) {
            self.object.link.setAttribute('href', data.link);
            self.object.link.classList.remove(self.class.hidden);
          } else {
            self.object.link.classList.add(self.class.hidden);
          }
        };

    // Lock animation
    self.options.animationInProgress = true;

    // Check if background has to change
    if (data.background.length > 0) {
      self.options.changeBackground = (data.background !== self.object.background.getAttribute('src'));
    } else {
      self.options.changeBackground = (self.options.defaultBackground !== self.object.background.getAttribute('src'));
    }

    // Handle select state
    this.handleSelectedState(eventObject, data);

    // Hide content
    await this.fade(true);

    // Change necessary data
    changeData(data);

    // Cache current event for prev / next button
    this.options.currentEvent = eventObject;

    // Display content
    await this.fade(false);

    // Lock animation
    self.options.animationInProgress = false;
  }

  getDataAttribute(key, value) {
    if (this.selector[key]) {
      if (value) {
        return '[' + this.selector[key] + '=\'' + value + '\']';
      }

      return '[' + this.selector[key] + ']';
    }

    return '';
  }

  getQuerySelector(key, value) {
    if (this.selector[key].length > 0) {
      if (value) {
        return document.querySelector(this.getDataAttribute(key, value));
      }

      return document.querySelector(this.getDataAttribute(key));
    }

    return null;
  }

  fade(isStarting) {
    let self = this,
        effectClass = (isStarting ? self.class.fadeOut : self.class.fadeIn),
        startAnimation = function() {
          // Handle animating class
          if (effectClass === self.class.fadeOut) {
            self.object.root.classList.add(self.class.animating);
            self.object.image.classList.add(self.class.invisible);
            self.object.year.classList.add(self.class.invisible);
            self.object.text.classList.add(self.class.invisible);

            if (self.options.changeBackground) {
              self.object.background.classList.add(self.class.invisible);
            }
          }

          // Handle effect classes
          self.object.image.classList.add(effectClass);
          self.object.year.classList.add(effectClass);
          self.object.text.classList.add(effectClass);

          if (self.options.changeBackground) {
            self.object.background.classList.add(effectClass);
          }
        },
        removeAnimation = function() {
          // Handle animating class
          if (effectClass !== self.class.fadeOut) {
            self.object.root.classList.remove(self.class.animating);
            self.object.image.classList.remove(self.class.invisible);
            self.object.year.classList.remove(self.class.invisible);
            self.object.text.classList.remove(self.class.invisible);
            self.object.background.classList.remove(self.class.invisible);
          }

          // Handle effect classes
          self.object.image.classList.remove(effectClass);
          self.object.year.classList.remove(effectClass);
          self.object.text.classList.remove(effectClass);
          self.object.background.classList.remove(effectClass);
        };

    return new Promise(resolve => {
      startAnimation();

      setTimeout(function () {
        removeAnimation();

        resolve();
      }, self.options.animationDuration);
    });
  }

  clickEvents() {
    const self = this;

    // Event on Start button to initialize the application
    document.querySelector(this.getDataAttribute('start')).addEventListener('click', async () => {
      let fadeOutStartScreen = async function() {
            return new Promise(resolve => {
              self.object.root.classList.add(self.class.animating);
              self.object.intro.classList.add(self.class.invisible);
              self.object.intro.classList.add(self.class.fadeOut);

              setTimeout(function() {
                self.object.intro.classList.add(self.class.hidden);
                self.object.intro.classList.remove(self.class.fadeOut);
                self.object.intro.classList.remove(self.class.invisible);

                resolve();
              }, self.options.animationDuration);
            });
          },
          fadeInWrapper = async function() {
            return new Promise(resolve => {
              self.object.wrapper.classList.add(self.class.invisible);
              self.object.wrapper.classList.remove(self.class.hidden);
              self.object.wrapper.classList.add(self.class.fadeIn);

              setTimeout(function() {
                self.object.wrapper.classList.remove(self.class.fadeIn);
                self.object.wrapper.classList.remove(self.class.invisible);
                self.object.root.classList.remove(self.class.animating);

                resolve();
              }, self.options.animationDuration);
            });
          };

      if (self.options.animationInProgress) {
        return null;
      }

      await fadeOutStartScreen();

      await fadeInWrapper();
    });

    // Event to handle click on every event dot
    document.querySelectorAll(this.getDataAttribute('recordEvent')).forEach((element) => {
      element.addEventListener('click', (event) => {
        if (self.options.animationInProgress) {
          return null;
        }
        self.displayEvent(event.currentTarget);
      });
    })

    // Event to handle click on every epoch dot
    document.querySelectorAll(this.getDataAttribute('recordEpoch')).forEach((element) => {
      element.addEventListener('click', (event) => {
        if (self.options.animationInProgress) {
          return null;
        }

        self.displayEvent(event.currentTarget.nextElementSibling);
      });
    })

    // Event to handle click on previous item button
    document.querySelector(this.getDataAttribute('buttonPrev')).addEventListener('click', () => {
      let event = self.options.currentEvent;

      if (self.options.animationInProgress) {
        return null;
      }

      while(event.previousElementSibling) {
        if (event.previousElementSibling.getAttribute(self.selector.recordEvent) > 0) {
          self.displayEvent(event.previousElementSibling);
          break;
        }

        event = event.previousElementSibling;
      }
    });

    // Event to handle click on next item button
    document.querySelector(this.getDataAttribute('buttonNext')).addEventListener('click', () => {
      let event = self.options.currentEvent;

      if (self.options.animationInProgress) {
        return null;
      }

      while(event.nextElementSibling) {
        if (event.nextElementSibling.getAttribute(self.selector.recordEvent) > 0) {
          self.displayEvent(event.nextElementSibling);
          break;
        }

        event = event.nextElementSibling;
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  new History();
});
